import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const FAPI_PRODUCT_PORTFOLIO_ENDPOINT = '/v1.0/productportfolio'

const GET_PRODUCT_PORTFOLIO_LIST = `${FAPI_PRODUCT_PORTFOLIO_ENDPOINT}/list`
const GET_SUGGESTIONS_PRODUCTS_LIST = `${FAPI_PRODUCT_PORTFOLIO_ENDPOINT}/suggest`
const IMPORT_FILE = `${FAPI_PRODUCT_PORTFOLIO_ENDPOINT}/import`
const EXPORT_FILE = `${FAPI_PRODUCT_PORTFOLIO_ENDPOINT}/export`

const apiClient = new HttpClient(environment.adminFAPIUrl)

export const fapiProductPortfolioService = {
  getProductPortfolioList({
    countryId,
    customerNumber,
    pageNumber,
    pageSize = 10,
    sortBy,
    orderBy,
    searchTerm,
  }) {
    return apiClient.get(GET_PRODUCT_PORTFOLIO_LIST, {
      params: {
        pageNumber,
        pageSize,
        sortBy,
        orderBy,
        searchTerm,
        countryId,
        customerNumber,
      },
    })
  },
  // new param field: language
  addProduct(data) {
    return apiClient.post(FAPI_PRODUCT_PORTFOLIO_ENDPOINT, {
      body: data,
    })
  },
  updateProduct(data) {
    return apiClient.put(FAPI_PRODUCT_PORTFOLIO_ENDPOINT, { body: data })
  },
  deleteProduct(data) {
    return apiClient.delete(FAPI_PRODUCT_PORTFOLIO_ENDPOINT, {
      body: data,
    })
  },
  getSuggestionsProductsList({
    query = '',
    countryId,
    customerNumber,
    cancelToken,
  }) {
    return apiClient.get(GET_SUGGESTIONS_PRODUCTS_LIST, {
      params: {
        query,
        countryId,
        customerNumber,
        from: 0,
        size: 10,
      },
      cancelToken,
    })
  },
  importFile(formData, selectedScope = {}) {
    const { countryId, customerNumber } = selectedScope
    const parameters = new URLSearchParams({})
    if (countryId) {
      parameters.append('countryId', countryId)
    }
    if (customerNumber) {
      parameters.append('customerNumber', customerNumber)
    }
    return apiClient.post(`${IMPORT_FILE}?${parameters.toString()}`, {
      body: formData,
      headers: {
        'content-type': 'multipart/form-data',
      },
    })
  },
  exportFile(customerNumber) {
    return apiClient.get(EXPORT_FILE, {
      params: { customerNumber },
    })
  },
}
